import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('SessionManagementReport_Center'),
			accessor: 'center',
			sortable: true
		},
		{
			header: t('SessionManagementReport_Date'),
			accessor: 'date',
			sortable: true,
			cell: date => ui.formatDate(date)
		},
		{
			header: t('SessionManagementReport_StartTime'),
			accessor: 'startTime',
			sortable: true,
			cell: startTime => ui.formatTime(startTime)
		},
		{
			header: t('SessionManagementReport_Grade'),
			accessor: 'grade',
			sortable: true
		},
		{
			header: t('SessionManagementReport_NormalLessons'),
			accessor: 'normalLessons',
			sortable: true
		},
		{
			header: t('SessionManagementReport_AttendedNormalLessons'),
			accessor: 'attendedNormalLessons',
			sortable: true
		},
		{
			header: t('SessionManagementReport_PaidTrialLessons'),
			accessor: 'paidTrialLessons',
			sortable: true
		},
		{
			header: t('SessionManagementReport_FreeTrialLessons'),
			accessor: 'freeTrialLessons',
			sortable: true
		},

	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);